export interface ReunionPluriprofessionnellePersonnelSoignant {
    id: string;
    nom: string;
    type: TypeEnum
    estPresent?: boolean;
}

export enum TypeEnum {
  RessourceInterne = "ressource_interne",
  IntervenantLieAuPatient = "intervenant_lie_au_patient",
  IntervenantExterne = "intervenant_externe",
}
